module.exports = __webpack_public_path__ + "media/staySafe.04256137.mp3";